<template>
	<swiper :options="{slidesPerView: 1, spaceBetween: 40, grabCursor: true, loop: true, loopFillGroupWithBlank: true,pagination: { el: '.swiper-pagination',clickable: true }}">
      <swiperSlide class="item home-slide bg-color-light" v-for="slideItem in homeSlides">
        <div class="item__wrap position-rel">
          <div class="row">
            <div class="col-md-6 col-xl-5">
              <div class="item__content">
                <h3 class="item__title font-size-30 font-sanpro-semibold primary-color-txt">{{slideItem.slideTitle}}</h3>
                <div class="item__icon text-center"><img :src="thumbUrl(slideItem.imageUrl)" class="img-150" alt=""></div>
                <p class="item__desc margin-0 font-size-18 primary-color-txt font-sanpro-light" v-html="slideItem.description">
                </p>
              </div>
            </div>
            <div class="col-md-6 col-xl-7">
              <div class="item__img">
                <img :src="thumbUrl(slideItem.slideImageUrl)">
              </div>
            </div>
          </div>
        </div>
      </swiperSlide>
      <div class="swiper-pagination home-slide" slot="pagination"></div>
    </swiper>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import {STORE_KEY} from '../_store/constants'
  import store from '../_store'
  import JWT from "@/utils/jwt"
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  const imgSlider1 = require('@/assets/img/home2_2.png');
  const imgSlider2 = require('@/assets/img/home2_1.png');

  export default {
    name: 'HomePageSlide',
    components: {
      swiper,
      swiperSlide 
    },
    data(){
      return{
        imgSlider1,
        imgSlider2
      }
    },
	computed: {
		...mapGetters({
		  homeSlides: STORE_KEY + '/homeSlides'
		})
	},
	mounted() {
		this.$store.dispatch(STORE_KEY + '/getHomeSlides',{});
	},
  methods: {      
    thumbUrl(filename) {
      return require(`@/assets${filename}`);
    }
  }
}
</script>